import React from "react";
import { Col, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { REGION_BUTTONS } from "../utils/filterConfig";

const RegionButtons = ({ setCAN, setCAC, setCAS }) => {
  const regionHandlers = { setCAN, setCAC, setCAS };
  
  return (
    <Col >
      <div className="location-filter__region-label mb-0">California:</div>
      <ToggleButtonGroup
        type="radio"
        name="options"
        defaultValue={0}
        className="location-filter__btn-group mb-0"
      >
        {REGION_BUTTONS.map((region) => (
          <ToggleButton 
            key={region.value}
            value={region.value} 
            onClick={regionHandlers[region.action]} 
            variant="gen-dark"
          >
            {region.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Col>
  );
};

export default RegionButtons;
